import { Tab, Tabs } from "@mui/material";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useEffect, useState } from "react";
import ClientsMessagesTable from "./ClientsMessagesTable";
import Filters from "../Widgets/Filters";
import { Filter, StatusItem } from "../../Utils/Types";
import { EComponentTypes } from "../../Utils/Enums";
import * as yup from "yup";
import { getData } from "../../Services/getData";
import { endpoints } from "../../Utils/UrlEnum";
import { toast } from "react-toastify";
import { ClientMessageModel } from "../../Utils/Models";
import genericStyles from "../../Styles/genericStyles.module.css";

interface MessagesProps {
  statuses: StatusItem[] | null;
}

export default function ClientMessages(props: MessagesProps) {
  const [value, setValue] = useState(0);
  const [statuses, setStatuses] = useState(props.statuses);
  const [types, setTypes] = useState();

  useEffect(() => {
    getData(`${endpoints.messages.statuses}`)
      .then((res) => {
        setStatuses(res.data);
      })
      .catch((err) => {
        toast.error(err);
      });

    getData(`${endpoints.messages.types}`)
      .then((res) => {
        setTypes(res.data);
      })
      .catch((err) => {
        toast.error(err);
      });
  }, []);

  const filters: Filter[] = [
    {
      property: "name",
      label: Vocabulary.name,
      type: EComponentTypes.TEXT,
      validation: yup.string(),
      defaultValue: null,
    },
    {
      property: "email",
      label: Vocabulary.email,
      type: EComponentTypes.TEXT,
      validation: yup.string(),
      defaultValue: null,
    },
    {
      property: "phone",
      label: Vocabulary.phone,
      type: EComponentTypes.TEXT,
      validation: yup.string(),
      defaultValue: null,
    },
    {
      property: "type",
      label: Vocabulary.type,
      type: EComponentTypes.AUTOCOMPLETE,
      validation: yup.mixed().nullable(),
      defaultValue: null,
      options: types,
      autocompleteFilterProperty: "name",
    },
    {
      property: "status",
      label: Vocabulary.status,
      type: EComponentTypes.AUTOCOMPLETE,
      validation: yup.mixed().nullable(),
      defaultValue: null,
      options: statuses,
      autocompleteFilterProperty: "name",
    },

  ];

  const clientMessage = new ClientMessageModel();

  const customClientFilter = {
    name: clientMessage.name,
    email: clientMessage.email,
    phone: clientMessage.phone,
  };

  function handleChangeValue(event: React.SyntheticEvent, newValue: number) {
    setValue(newValue);

    const url = new URL(window.location.href);
    url.searchParams.set("type", newValue === 1 ? "messages" : "null");

    // This updates the URL without reloading the page
    window.history.pushState({}, "", url);
  }


  return (
    <div className={genericStyles.mainContainer}>
      <Filters filters={filters} customFilterModel={customClientFilter} />
      <Tabs value={value} onChange={handleChangeValue} textColor="inherit">
        <Tab label={Vocabulary.clientMessages} />
      </Tabs>
      <ClientsMessagesTable statuses={statuses || null} />
    </div>
  );
}
